export default __webpack_public_path__ + "static/media/Reader's Bracelets of Awakening.4845571c.jpg";